export const zeroPadding = (val: string | null, length: number) => {
  return val ? (Array(length).join('0') + val).slice(-length) : ''
}
